import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type RestockDashboardItemFragment = { __typename?: 'ItemSummaryDocument', id: string, itemId: string, itemLookupCode: string, sku: string, name: string, group: string, productGroup: string, erpId: string };

export type GetRestockDashboardItemsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ItemSummaryDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ItemSummaryDocumentSortInput> | Types.ItemSummaryDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetRestockDashboardItemsQuery = { __typename?: 'Query', items?: { __typename?: 'ItemsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ItemSummaryDocument', id: string, itemId: string, itemLookupCode: string, sku: string, name: string, group: string, productGroup: string, erpId: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetRestockDailyDemandSummaryQueryVariables = Types.Exact<{
  asOf: Types.Scalars['DateTime']['input'];
  weeksOfSupply?: Types.InputMaybe<Types.Scalars['Decimal']['input']>;
  station?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetRestockDailyDemandSummaryQuery = { __typename?: 'Query', restockDailyDemandSummary: { __typename?: 'RestockDailyDemandSummaryData', rowCount: number, totalDemand: number, totalAchievable: number, totalAvailable: number, latestCalcDate?: Types.TDateISO | null } };

export type RestockDashboardStoreRowFragment = { __typename?: 'RestockDashboardStoreRowData', customerCode: string, customerId?: string | null, locationCode: string, customerLocationId?: string | null, storeName?: string | null, storeNumber?: string | null, storeClass?: string | null, totalDemand: number, itemCount: number, lastCalculatedAt?: Types.TDateISO | null, restockIndex?: number | null, decayedScore?: number | null, weeksSinceShip?: number | null, thresholdWeeks?: number | null, lastDeliveryDate?: Types.TDateISO | null, allocationReason: Types.RestockAllocationReason, sales4Wk?: number | null, velocity4Wk?: number | null, restockIndexBreakdown?: { __typename?: 'RestockIndexBreakdownData', demandScore: number, wosScore: number, velocityScore: number, rankBonus: number } | null, allocationBreakdown?: { __typename?: 'RestockAllocationBreakdownData', tier: string, thresholdWeeks: number, weeksSinceShip?: number | null, lastDeliveryDate?: Types.TDateISO | null, decayedScore?: number | null, reason: Types.RestockAllocationReason, halfLifeDays: number, lookbackDays: number } | null };

export type GetRestockDashboardRowsQueryVariables = Types.Exact<{
  itemCodes?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
  locationCodes?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
  station?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetRestockDashboardRowsQuery = { __typename?: 'Query', restockDashboardStoreRows: Array<{ __typename?: 'RestockDashboardStoreRowData', customerCode: string, customerId?: string | null, locationCode: string, customerLocationId?: string | null, storeName?: string | null, storeNumber?: string | null, storeClass?: string | null, totalDemand: number, itemCount: number, lastCalculatedAt?: Types.TDateISO | null, restockIndex?: number | null, decayedScore?: number | null, weeksSinceShip?: number | null, thresholdWeeks?: number | null, lastDeliveryDate?: Types.TDateISO | null, allocationReason: Types.RestockAllocationReason, sales4Wk?: number | null, velocity4Wk?: number | null, restockIndexBreakdown?: { __typename?: 'RestockIndexBreakdownData', demandScore: number, wosScore: number, velocityScore: number, rankBonus: number } | null, allocationBreakdown?: { __typename?: 'RestockAllocationBreakdownData', tier: string, thresholdWeeks: number, weeksSinceShip?: number | null, lastDeliveryDate?: Types.TDateISO | null, decayedScore?: number | null, reason: Types.RestockAllocationReason, halfLifeDays: number, lookbackDays: number } | null }> };

export type GetRestockDashboardStoreRowsBlockQueryVariables = Types.Exact<{
  itemCodes?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
  locationCodes?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
  station?: Types.InputMaybe<Types.Scalars['String']['input']>;
  offset: Types.Scalars['Int']['input'];
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  sort?: Types.InputMaybe<Array<Types.RestockDashboardStoreRowSortInput> | Types.RestockDashboardStoreRowSortInput>;
  filter?: Types.InputMaybe<Types.RestockDashboardStoreRowFilterInput>;
}>;


export type GetRestockDashboardStoreRowsBlockQuery = { __typename?: 'Query', restockDashboardStoreRowsBlock: { __typename?: 'RestockDashboardStoreRowsBlockData', totalCount: number, nodes: Array<{ __typename?: 'RestockDashboardStoreRowData', customerCode: string, customerId?: string | null, locationCode: string, customerLocationId?: string | null, storeName?: string | null, storeNumber?: string | null, storeClass?: string | null, totalDemand: number, itemCount: number, lastCalculatedAt?: Types.TDateISO | null, restockIndex?: number | null, decayedScore?: number | null, weeksSinceShip?: number | null, thresholdWeeks?: number | null, lastDeliveryDate?: Types.TDateISO | null, allocationReason: Types.RestockAllocationReason, sales4Wk?: number | null, velocity4Wk?: number | null, restockIndexBreakdown?: { __typename?: 'RestockIndexBreakdownData', demandScore: number, wosScore: number, velocityScore: number, rankBonus: number } | null, allocationBreakdown?: { __typename?: 'RestockAllocationBreakdownData', tier: string, thresholdWeeks: number, weeksSinceShip?: number | null, lastDeliveryDate?: Types.TDateISO | null, decayedScore?: number | null, reason: Types.RestockAllocationReason, halfLifeDays: number, lookbackDays: number } | null }> } };

export const RestockDashboardItemFragmentDoc = new TypedDocumentString(`
    fragment RestockDashboardItem on ItemSummaryDocument {
  id
  itemId
  itemLookupCode
  sku
  name
  group
  productGroup
  erpId
}
    `, {"fragmentName":"RestockDashboardItem"});
export const RestockDashboardStoreRowFragmentDoc = new TypedDocumentString(`
    fragment RestockDashboardStoreRow on RestockDashboardStoreRowData {
  customerCode
  customerId
  locationCode
  customerLocationId
  storeName
  storeNumber
  storeClass
  totalDemand
  itemCount
  lastCalculatedAt
  restockIndex
  restockIndexBreakdown {
    demandScore
    wosScore
    velocityScore
    rankBonus
  }
  decayedScore
  weeksSinceShip
  thresholdWeeks
  lastDeliveryDate
  allocationReason
  sales4Wk
  velocity4Wk
  allocationBreakdown {
    tier
    thresholdWeeks
    weeksSinceShip
    lastDeliveryDate
    decayedScore
    reason
    halfLifeDays
    lookbackDays
  }
}
    `, {"fragmentName":"RestockDashboardStoreRow"});
export const GetRestockDashboardItemsDocument = new TypedDocumentString(`
    query GetRestockDashboardItems($where: ItemSummaryDocumentFilterInput, $order: [ItemSummaryDocumentSortInput!], $first: Int, $after: String) {
  items(where: $where, order: $order, first: $first, after: $after) {
    nodes {
      ...RestockDashboardItem
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment RestockDashboardItem on ItemSummaryDocument {
  id
  itemId
  itemLookupCode
  sku
  name
  group
  productGroup
  erpId
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetRestockDailyDemandSummaryDocument = new TypedDocumentString(`
    query GetRestockDailyDemandSummary($asOf: DateTime!, $weeksOfSupply: Decimal, $station: String) {
  restockDailyDemandSummary(
    asOf: $asOf
    weeksOfSupply: $weeksOfSupply
    station: $station
  ) {
    rowCount
    totalDemand
    totalAchievable
    totalAvailable
    latestCalcDate
  }
}
    `);
export const GetRestockDashboardRowsDocument = new TypedDocumentString(`
    query GetRestockDashboardRows($itemCodes: [String!], $locationCodes: [String!], $station: String) {
  restockDashboardStoreRows(
    itemCodes: $itemCodes
    locationCodes: $locationCodes
    station: $station
  ) {
    ...RestockDashboardStoreRow
  }
}
    fragment RestockDashboardStoreRow on RestockDashboardStoreRowData {
  customerCode
  customerId
  locationCode
  customerLocationId
  storeName
  storeNumber
  storeClass
  totalDemand
  itemCount
  lastCalculatedAt
  restockIndex
  restockIndexBreakdown {
    demandScore
    wosScore
    velocityScore
    rankBonus
  }
  decayedScore
  weeksSinceShip
  thresholdWeeks
  lastDeliveryDate
  allocationReason
  sales4Wk
  velocity4Wk
  allocationBreakdown {
    tier
    thresholdWeeks
    weeksSinceShip
    lastDeliveryDate
    decayedScore
    reason
    halfLifeDays
    lookbackDays
  }
}`);
export const GetRestockDashboardStoreRowsBlockDocument = new TypedDocumentString(`
    query GetRestockDashboardStoreRowsBlock($itemCodes: [String!], $locationCodes: [String!], $station: String, $offset: Int!, $limit: Int, $sort: [RestockDashboardStoreRowSortInput!], $filter: RestockDashboardStoreRowFilterInput) {
  restockDashboardStoreRowsBlock(
    itemCodes: $itemCodes
    locationCodes: $locationCodes
    station: $station
    offset: $offset
    limit: $limit
    sort: $sort
    filter: $filter
  ) {
    nodes {
      ...RestockDashboardStoreRow
    }
    totalCount
  }
}
    fragment RestockDashboardStoreRow on RestockDashboardStoreRowData {
  customerCode
  customerId
  locationCode
  customerLocationId
  storeName
  storeNumber
  storeClass
  totalDemand
  itemCount
  lastCalculatedAt
  restockIndex
  restockIndexBreakdown {
    demandScore
    wosScore
    velocityScore
    rankBonus
  }
  decayedScore
  weeksSinceShip
  thresholdWeeks
  lastDeliveryDate
  allocationReason
  sales4Wk
  velocity4Wk
  allocationBreakdown {
    tier
    thresholdWeeks
    weeksSinceShip
    lastDeliveryDate
    decayedScore
    reason
    halfLifeDays
    lookbackDays
  }
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetRestockDashboardItems: build.query<GetRestockDashboardItemsQuery, GetRestockDashboardItemsQueryVariables | void>({
      query: (variables) => ({ document: GetRestockDashboardItemsDocument, variables })
    }),
    GetRestockDailyDemandSummary: build.query<GetRestockDailyDemandSummaryQuery, GetRestockDailyDemandSummaryQueryVariables>({
      query: (variables) => ({ document: GetRestockDailyDemandSummaryDocument, variables })
    }),
    GetRestockDashboardRows: build.query<GetRestockDashboardRowsQuery, GetRestockDashboardRowsQueryVariables | void>({
      query: (variables) => ({ document: GetRestockDashboardRowsDocument, variables })
    }),
    GetRestockDashboardStoreRowsBlock: build.query<GetRestockDashboardStoreRowsBlockQuery, GetRestockDashboardStoreRowsBlockQueryVariables>({
      query: (variables) => ({ document: GetRestockDashboardStoreRowsBlockDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetRestockDashboardItemsQuery, useLazyGetRestockDashboardItemsQuery, useGetRestockDailyDemandSummaryQuery, useLazyGetRestockDailyDemandSummaryQuery, useGetRestockDashboardRowsQuery, useLazyGetRestockDashboardRowsQuery, useGetRestockDashboardStoreRowsBlockQuery, useLazyGetRestockDashboardStoreRowsBlockQuery } = injectedRtkApi;
